import React, { useState } from "react";
import authImage from "../../assets/images/auth-image.png";
import SectionHeader from "../../components/ui/HeaderSection";
import InputField from "../../components/ui/InputField";
import Button from "../../components/ui/Button";
import GoogleButton from "../../components/ui/GoogleButton";
import PlainNavbar from "../../components/layout/PlainNavbar";
import VerificationModal from "../../components/ui/VerificationModal";

const RegisterPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <PlainNavbar />
      <div className="flex min-h-screen">
        {" "}
        {/* Gambar di sebelah kiri */}
        <div className="w-2/3 hidden lg:block overflow-hidden h-[142vh]">
          <img src={authImage} alt="Auth" className="w-full object-cover" />
        </div>
        {/* Form Register */}
        <div className="w-full lg:w-1/2 flex flex-col justify-start px-10 mt-10">
          {/* Header with left alignment */}
          <div className="text-left mt-20">
            <SectionHeader
              title="Buat Akun Wedify"
              description="Gabung sekarang dan temukan pengalaman terbaik untuk merencanakan momen spesial Anda!"
              TitleColor="#010203"
              DescriptionColor="#ABABAB"
              textAlign="left"
            />
          </div>

          {/* Form */}
          <div className="mt-6 space-y-4">
            <InputField
              title="Nama"
              placeholder="Masukkan nama Anda"
              type="text"
            />
            <InputField
              title="Email"
              placeholder="Masukkan email Anda"
              type="email"
            />
            <InputField
              title="Nomor Handphone"
              placeholder="Masukkan nomor handphone aktif Anda"
              type="number"
            />
            <InputField
              title="Password"
              placeholder="Masukkan password 8 - 16 karakter"
              type="password"
            />
            <InputField
              title="Konfirmasi Password"
              placeholder="Ulangi kembali password yang Anda tulis"
              type="password"
            />
            <InputField
              title="Darimana Anda Mengetahui Wedify?"
              type="select"
              options={[
                "Pilih salah satu",
                "Media Sosial",
                "Teman",
                "Iklan",
                "Lainnya",
              ]}
            />
          </div>

          {/* Checkbox */}
          <div className="mt-4 flex items-center gap-2">
            <input type="checkbox" className="w-4 h-4" />
            <p className="text-sm text-gray-600">
              Dengan mendaftar, saya menyetujui{" "}
              <a href="/terms-of-service" className="text-blue-500 font-medium">
                Syarat & Ketentuan
              </a>{" "}
              yang berlaku.
            </p>
          </div>

          {/* Button Daftar */}
          <div className="mt-3 w-full">
            <Button
              text="Daftar"
              fullWidth={true}
              className="w-full"
              onClick={() => setIsModalOpen(true)}
            />
          </div>

          {/* Divider */}
          <div className="flex items-center my-4">
            <hr className="flex-grow border-gray-300" />
            <span className="px-2 text-gray-500 text-sm">OR</span>
            <hr className="flex-grow border-gray-300" />
          </div>

          {/* Google Sign-In */}
          <GoogleButton />

          {/* Login Link */}
          <p className="mt-4 pb-6 text-center text-sm text-gray-600">
            Sudah Punya Akun?{" "}
            <a href="/login" className="text-blue-500 font-medium">
              Masuk Sekarang
            </a>
          </p>
          <VerificationModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
        </div>
      </div>
    </>
  );
};

export default RegisterPage;
